import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SlCancelIcon",
  "use": "SlCancelIcon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SlCancelIcon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0C5.371 0 0 5.373 0 12s5.372 12 12 12z\" fill=\"#7E8FA8\" /><path d=\"M14.829 9.176l-5.657 5.656M9.172 9.176l5.656 5.656\" stroke=\"#fff\" stroke-width=\"1.25\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol